var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      attrs: {
        btnUnuse: _vm.btnUnuse,
        showMask: true,
        singleBtn: true,
        closeIcon: true,
        title: _vm.$t("tradeTxPairManage.changeOwner"),
        leftBtnTxt: _vm.$t("tradeTxPairManage.submitChange"),
        leftBtnClick: _vm.trans,
        close: _vm.close
      }
    },
    [
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("tradeTxPairManage.txPairName")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
          _vm._v(_vm._s(_vm.txPair.symbol || ""))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "__row" },
        [
          _c("div", { staticClass: "__row_t" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeOperator.permissionConfirm.address")) +
                "\n            "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isValidAddress,
                    expression: "!isValidAddress"
                  }
                ],
                staticClass: "__err"
              },
              [_vm._v(_vm._s(_vm.$t("hint.addrFormat")))]
            )
          ]),
          _vm._v(" "),
          _c("vite-input", {
            attrs: {
              valid: _vm.validAddr,
              placeholder: _vm.$t("wallet.placeholder.addr")
            },
            model: {
              value: _vm.address,
              callback: function($$v) {
                _vm.address = $$v
              },
              expression: "address"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "__notice" }, [
        _c("span", [
          _vm._v(_vm._s(_vm.$t("tradeTxPairManage.changeOwnerHint")))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }